export enum AppViewMode {
  ICONS = 'icons',
  CARDS = 'cards',
  LIST = 'list',
}
